/** Short-lived cookie: pathname + search to return to after work-email verification. */
export const WORK_EMAIL_VERIFICATION_RETURN_PATH_KEY =
  'work_email_verification_return_path';

export const WORK_EMAIL_VERIFICATION_RETURN_MAX_AGE_SEC = 600;
